module.exports = __webpack_public_path__ + "static/media/parceiro-ordem-biologos.fb82aeb1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/parceiro-ordem-biologos.jpg
// module id = 162
// module chunks = 0